import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Amount, GeneralPricingMode } from '@mews-commander/data-access';
import { DividerList, LabeledListItem } from '@mews-commander/ui';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { Tag } from '@optimus-web/core';

interface Props {
    pricing: Amount;
}

export const AbsolutePricingSection = ({ pricing }: Props) => {
    const { pricing: enterprisePricing } = useCurrentEnterprise();
    return (
        <DividerList>
            <LabeledListItem label={lt('PricingType')}>
                <Tag variant="basicSubtle" outline>
                    {lt('Fixed')}
                </Tag>
            </LabeledListItem>
            <LabeledListItem label={lt('Currency')}>{pricing.currency}</LabeledListItem>
            <LabeledListItem label={lt('Price')}>
                <LocalizedCurrencyValue
                    value={{
                        value: enterprisePricing === GeneralPricingMode.Gross ? pricing.grossValue : pricing.netValue,
                        currency: pricing.currency,
                    }}
                />
            </LabeledListItem>
        </DividerList>
    );
};
